module.exports = __webpack_public_path__ + "assets/7aef3157df19d0846d17bba1c0484e84.png";